import React from "react";
import "../styles/Blog.css";
import { blogPosts } from "../data/blogPosts";

export default function Blog({ embedded = false, navigate }) {
  const sorted = [...blogPosts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const handleReadMore = (slug) => {
    if (navigate) {
      navigate(`/blog/${slug}`);
    } else {
      window.history.pushState({}, "", `/blog/${slug}`);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  return (
    <section id="blog" className={`blog-section${embedded ? " blog-embedded" : ""}`}>
      <h1 className="blog-heading">Latest Blogs</h1>
      <p className="blog-intro">
        Cloud computing, DevOps, AWS, and Azure guides — practical insights for learners and IT professionals.
      </p>

      <div className="blog-grid">
        {sorted.map((blog) => (
          <article className="blog-card" key={blog.slug} itemScope itemType="https://schema.org/BlogPosting">
            <span className="blog-tag">{blog.tag}</span>
            <h2 itemProp="headline">
              <button
                type="button"
                className="blog-card-title-btn"
                onClick={() => handleReadMore(blog.slug)}
              >
                {blog.title}
              </button>
            </h2>
            <p itemProp="description">{blog.desc}</p>
            <meta itemProp="datePublished" content={blog.date} />
            <button
              type="button"
              className="read-btn"
              onClick={() => handleReadMore(blog.slug)}
              aria-label={`Read more about ${blog.title}`}
            >
              Read More
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
